import type { NextPageWithLayout } from "@/shared/lib/types/layoutTypes";
import { AuthLayout } from "@/widgets/AuthLayout";
import SignUpWidget from "@/widgets/SignUpWidget";
import { AuthFormFeaturesUi } from "@features/AuthFormFeatures";

const SignUp: NextPageWithLayout = () => {
	return (
		<AuthFormFeaturesUi.AuthFormLayout imageAltText="Sign Up Image">
			<SignUpWidget />
		</AuthFormFeaturesUi.AuthFormLayout>
	);
};

SignUp.getLayout = AuthLayout;

export default SignUp;
